import { useEffect, useRef, useCallback } from 'react';

export const useIdleTimeout = (
  onIdle: () => void,
  idleTimeMs: number = 5 * 60 * 1000, // 5 minutos por defecto
  enabled: boolean = true
) => {
  const idleTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleIdle = useCallback(() => {
    if (enabled) {
      onIdle();
    }
  }, [onIdle, enabled]);

  const resetTimer = useCallback(() => {
    if (idleTimeoutRef.current) {
      clearTimeout(idleTimeoutRef.current);
    }
    if (enabled) {
      idleTimeoutRef.current = setTimeout(handleIdle, idleTimeMs);
    }
  }, [handleIdle, idleTimeMs, enabled]);

  useEffect(() => {
    if (!enabled) return;

    const events = [
      'mousemove',
      'mousedown',
      'keydown',
      'touchstart',
      'scroll'
    ];

    const handleEvent = () => resetTimer();

    // Inicializar el timer
    resetTimer();

    // Agregar listeners
    events.forEach(event => {
      document.addEventListener(event, handleEvent, { passive: true });
    });

    // Cleanup
    return () => {
      if (idleTimeoutRef.current) {
        clearTimeout(idleTimeoutRef.current);
      }
      events.forEach(event => {
        document.removeEventListener(event, handleEvent);
      });
    };
  }, [resetTimer, enabled]);
};
